import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-promoters",
  "use": "foquz-icon-rating-promoters-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-promoters\"><path d=\"M8.423 7.999a2.046 2.046 0 00-2.892-.022M14.477 8a2.045 2.045 0 00-2.892-.022m1.397 4.832a4.092 4.092 0 01-5.786.042M19 10a9 9 0 11-18 0 9 9 0 0118 0z\" stroke=\"#00C968\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol